@if ($output().src) {
    <img [src]="$output().src | sanitize:'bypassSecurityTrustResourceUrl'" />
}